import styled from 'styled-components'
import { Section } from 'style'

export const StyledSection = styled(Section)``
